qw-calendar-shorthand {
  display: flex;
}
